import Button from "shared/components/button/Button";
import { SPACES_ROUTE } from 'app/navigation/routes/space-routes';
import { useCallback } from 'react';
import { useNavigationContext } from 'shared/providers/NavigationProvider';
import { useTranslation } from 'react-i18next';

const spaceId = "bad01f337848a84f8ce0e2b74744b2c98287456dcb5818a1b69013d62bf2d6a0";

// TO-DO: This is the same as PopularSpace; so, refactor.

const PopularConferenceRoom = ({ height = '60vh'}) => {

    const { t } = useTranslation();
    const { navigateToRouteWithState } = useNavigationContext();

        const handleNavigateToSpaceDetailsPage = useCallback(() => navigateToRouteWithState({
            path: `${SPACES_ROUTE}/${spaceId}`,
            state: spaceId
        }),
            [navigateToRouteWithState]
        );

  return (
      <div
          className="w-full flex justify-center items-end relative rounded-xl overflow-hidden"
          style={{
              backgroundImage:
                  "url('https://res.cloudinary.com/dorkbt39x/image/upload/v1765321651/meets-N-works/CA-NAPA/DSC02854_CA_NAPA_commercial_tower_ie8se0.png')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              height
          }}
      >
          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-black/40"></div>

          {/* Overlay Text */}
          <div className="absolute bottom-6 left-6 text-white space-y-2">
              <span className="text-xs font-semibold ">
                  {t('website.popularSpaces.conferenceRoom.badge')}
              </span>

              <h3 className="text-2xl font-bold tracking-tight drop-shadow-lg">
                  {t('website.popularSpaces.conferenceRoom.title')}
              </h3>

              <p className="text-sm text-gray-200 max-w-xs leading-relaxed drop-shadow-md">
                  {t('website.popularSpaces.conferenceRoom.description')}
              </p>

              <Button
                  onClick={handleNavigateToSpaceDetailsPage}
                  className="mt-20  px-4 py-2 text-xs font-semibold bg-white/20 hover:bg-lime-700 backdrop-blur-sm rounded-md"
              >
                  {t('website.popularSpaces.viewDetails')}
              </Button>
          </div>
      </div>
  );
};

export default PopularConferenceRoom;
